export const getSecondsInMilliseconds = (seconds: number) => 1000 * seconds;

export const getMinutesInMilliseconds = (minutes: number) => 1000 * 60 * minutes;

export const getDaysInMilliseconds = (days: number) => 1000 * 60 * 60 * 24 * days;
